import {createActions} from 'client/framework';

const normalActions = ['SET_GUESS_ENTITIES'];

export default createActions(null, normalActions);
